<template>
  <div>
    <div class="headline">ตัวอย่างข้อความที่เลือก</div>
    <div style="border: 1px solid #eee; border-radius: 10px" class="pa-2">
      <div v-if="questions.length == 0" class="text-xs-center my-4">No data</div>
      <template v-else>
        <ul class="tags">
          <template v-for="(word, index) in questions">
            <li
              :key="'word_' + word.id + '_' + index"
              class="tag"
              :class="{ active: selected.includes(word.questiondata) || isSelectable == false }"
              style="margin-right: 5px; margin-bottom: 5px; cursor: pointer; text-align: left"
              :title="word.questiondata"
              @click="handleToggleQuestiondata(word.questiondata)"
            >
              <span
                :class="{
                  'fas fa-check-circle': selected.includes(word.questiondata) || isSelectable,
                  'far fa-circle': !selected.includes(word.questiondata) || isSelectable == false
                }"
              ></span>
              <div style="display: inline-block; vertical-align: middle; word-break: break-all">
                {{ word.questiondata }}
                <template v-if="word.score > 0">{{ word.score | decimalFormat }}</template>
              </div>
              <template v-if="word.count > 1">({{ word.count }})</template>
            </li>
          </template>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questions: {
      default: []
    },
    selected: {
      default: []
    },
    isSelectable: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    handleToggleQuestiondata(questiondata) {
      if (this.isSelectable) {
        this.$emit('onToggleQuestiondata', questiondata)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/QuestionDataExample.vue